import type { TFavoriteColors, TTransportType } from 'api/swagger';
import type { EMapMarkerType } from 'types/map';

interface ICommonAddMarkerOptions {
  map: google.maps.Map;
  title: string;
  position: {
    lat: number;
    lng: number;
  };
  warning?: boolean;
  favorites?: TFavoriteColors[];
}

export interface IAddMarkerOptions extends ICommonAddMarkerOptions {
  costValue?: string;
  type?: EMapMarkerType;
  onClick?: () => void;
  isBelong?: boolean;
  costView?: boolean;
}

export interface IAddTransportMarkerOptions extends ICommonAddMarkerOptions {
  type: TTransportType;
  trailerPlateNumber?: string;
  extraData?: string[];
}

export enum EMarkersZIndexes {
  TRANSPORT_MARKERS = 35,
  CLIENT_BELONGS_MARKERS = 30,
  OTHER_MARKERS = 10,
}
